<template>
  <cs-basic>
    <template v-slot:header>
      <login-header app="sso" />
    </template>
    <template v-slot:content>
      <type-your-email />
    </template>
    <template v-slot:footer>
      <login-footer />
    </template>
  </cs-basic>
</template>

<script>
import csBasic from '@/layouts/csBasic.vue'
import loginHeader from '@/components/header/loginHeader.vue'
import loginFooter from '@/components/loginFooter.vue'
import typeYourEmail from '@/components/forgotPassword/typeYourEmail.vue'

export default {
  components: {
    csBasic,
    loginHeader,
    loginFooter,
    typeYourEmail
  }
}
</script>

<style></style>
